// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2BPvc","label":"SetPasswdForm_label__1hlCe"};